import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 34, height: 34, viewBox: "0 0 35 35", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 17, cy: 17, r: 17, fill: "#FFB800" }), /* @__PURE__ */ React.createElement("path", { d: "M15 6H19L18 23H16L15 6Z", fill: "white" }), /* @__PURE__ */ React.createElement("rect", { x: 15, y: 25, width: 4, height: 4, rx: 2, fill: "white" }));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
